interface TestimonialCardProps {
  quote: string
  name: string
  title: string
  company: string
  companyUrl?: string
  avatar?: string
}

export default function TestimonialCard({ 
  quote, 
  name, 
  title, 
  company, 
  companyUrl,
  avatar
}: TestimonialCardProps) {
  return (
    <div className="card-hover p-8 border border-border hover:border-primary transition-all duration-slow bg-card h-full flex flex-col gap-6">
      {/* Top section: Avatar and attribution side by side */}
      <div className="flex gap-6">
        {/* Avatar - Smaller square on the left */}
        {avatar && (
          <div className="flex-shrink-0">
            <img 
              src={avatar} 
              alt={`${name} avatar`}
              className="w-20 h-20 object-cover border-2 border-primary"
            />
          </div>
        )}
        
        {/* Attribution on the right of photo */}
        <div className="flex flex-col justify-center">
          <p className="text-h5 mb-1">{name}</p>
          <p className="text-micro uppercase tracking-widest text-muted-foreground mb-1">
            {title}
          </p>
          {companyUrl ? (
            <a 
              href={companyUrl} 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-micro uppercase tracking-widest text-primary hover:text-primary-hover transition-colors"
            >
              {company}
            </a>
          ) : (
            <p className="text-micro uppercase tracking-widest text-primary">
              {company}
            </p>
          )}
        </div>
      </div>
      
      {/* Quote stretches full width below */}
      <blockquote className="text-body-sm text-foreground leading-relaxed pt-6 border-t border-border">
        "{quote}"
      </blockquote>
    </div>
  )
}